<template>
<article
  :id="card_id"
  class="card"
  ref="card"
>
  <div class="card-body">
  <template v-if="!cardAlwaysExpanded">
    <header
        class="card-title d-flex flex-nowrap align-items-center"
        :class="{ 'collapsed': !state }"
        :id="title_id"
        aria-controls=".toggle-target" :aria-expanded="state"
        @keydown="onKeydown"
        @click="onToggle"
        role="button"
        tabindex="0"
    >
      <div class="flex-grow-1">
        <slot name="header">
          <h1 class="h4"><slot name="title" /></h1>
        </slot>
      </div>
      <div class="btn btn-link text-decoration-none text-dark caret">
        <FontAwesomeIcon :icon="faChevronDown"/>
      </div>
    </header>
  </template>
  <template v-else-if="$slots.header || $slots.title">
    <header
      class="card-title d-flex flex-nowrap align-items-center"
      :id="title_id"
    >
      <div class="flex-grow-1">
        <slot name="header">
          <h1 class="h4"><slot name="title" /></h1>
        </slot>
      </div>
    </header>
  </template>
  <template v-if="$slots.visually_hidden_header">
    <header class="visually-hidden">
      <slot name="visually_hidden_header"></slot>
    </header>
  </template>
  <div class="card-title" v-if="$slots.always_visible">
    <slot name="always_visible"></slot>
  </div>
  <BCollapse v-if="!cardAlwaysExpanded" class="toggle-target" v-model="state">
    <slot name="contentPre" />
    <slot name="content" />
    <slot></slot>
  </BCollapse>
  <div v-else>
    <slot name="contentPre" />
    <slot name="content" />
    <slot></slot>
  </div>
  <slot name="ps"></slot>
  <slot name="footer" />
  </div>
</article>
</template>
<script setup lang="ts">
import { uniqueId } from 'lodash-es';
import { ref } from 'vue';

import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { BCollapse } from 'bootstrap-vue-next';

const props = withDefaults(
  defineProps<{
    expanded?: boolean
    cardAlwaysExpanded?: boolean
  }>(),
  {
    expanded: true,
    cardAlwaysExpanded: false,
  }
)

const card_id = uniqueId()
const title_id = `${card_id}-title`

const state = ref(props.expanded || props.cardAlwaysExpanded)

function onToggle() {
  state.value  = !state.value
}

const onKeydown = ((event: KeyboardEvent) => {
  if ([' ', 'Enter'].includes(event.key)) {
    event.preventDefault()
    event.stopPropagation()

    onToggle()
  }
}) as EventListener
</script>
<style scoped>
.card-title.collapsed .fa-chevron-down {
  transform: rotate(-90deg)
}
</style>
